module.exports = {
  popup_hints: {
    grid_layout_settings: 'Изменить размер и расположение графиков',
  },
  interval_under_label: {
    from: 'с',
    to: 'по',
  },
  system: {
    none_projectMetric_info:
      'В данном аналитическом проекте нет созданных метрик, построение графика невозможно',
    no_metric: 'Одна из метрик графика удалена,график не может быть построен',
    no_access: 'Нет доступа к данным отчета и графика.',
    no_data: 'Нет данных.',
  },
  choose_category: 'Категория',
  status: 'Статус',
  empty: 'В отчете нет графиков',
  new_chart: 'Новый график',
  loading: 'Поиск графиков',
  menu: 'Меню',
  barchart: 'Гистограмма',
  horizontal_barchart: 'Горизонтальные бары',
  columnchart: 'Сегментированная гистограмма',
  piechart: 'Круговая',
  linechart: 'Линейный график',
  yaxis_min_value: 'Ось Y от минимума',
  popover: {
    add_diagram: 'Добавить диаграмму',
    gist: 'Гистограмма',
  },
  drop_menu: {
    intervals: 'Задать временной период для всех диаграмм',
    edit: 'Редактировать',
    edit_period: 'Настроить период',
    remove: 'Удалить',
    download_svg: 'Скачать SVG',
    download_csv: 'Скачать CSV',
    download_png: 'Скачать PNG',
    to_report: 'Перейти в отчет',
    toolbar: 'Панель инструментов',
  },
  order_by_options: {
    asc: 'По возрастанию',
    desc: 'По убыванию',
    none: 'Нет',
  },
  legend_position_options: {
    bottom: 'Внизу',
    left: 'Слева',
    right: 'Справа',
  },
  value_positions_options: {
    inside: 'Внутри',
    outside: 'Снаружи',
  },
  empty_charts: 'У отчета еще нет графиков',
  remove_chart_title: 'Удалить график',
  remove_chart_body: 'Вы точно хотите удалить?',
  select: {
    date_placeholder: 'Выберите дату',
    day: '1 день',
    weekdays: '7 дней',
    monthDays: '30 дней',
    today: 'Текущий день',
    week: 'Текущая неделя',
    month: 'Текущий месяц',
    all_data: 'Все данные',
    custom_date: 'Диапазон',
    aggregate_choices: 'Выбрать',
    metric_choices: 'Выбрать',
    color_choices: 'Изменить',
    prevDay: 'Предыдущий день',
    prevWeek: 'Предыдущая неделя',
    prevMonth: 'Предыдущий месяц',
    prevQuarter: 'Предыдущий квартал',
    currentQuarter: 'Текущий квартал',
  },
  labels: {
    customizing_data_to_display_on_a_histogram_y1:
      'Настройка данных для отображения на гистограмме (вертикальная ось Y1)',
    customizing_data_to_display_on_a_histogram_y2:
      'Настройка данных для отображения на гистограмме (вертикальная ось Y2)',
    additional_vertical_axis: 'Дополнительная вертикальная ось',
    metric_axis: 'Выбор метрики',
    metric_axis_y2: 'Выбор метрики (ось Y2)',
    aggregate_data: 'Значения на диаграмме',
    label_color_col: 'Цвет',
    label_color_line: 'Цвет линии',
  },
  button: {
    remove_chart: 'Удалить график?',
    color_edit: 'Изменить',
  },
  interval_error: 'Интервал не указан или неверный интервал',
  modal_remove_chart_title: 'Подтвердите удаление',
  modal_interval_title: 'Задать период для всех графиков',
  modal_interval_success_button: 'Применить',
  modal_interval_before: 'от',
  modal_interval_after: 'до',
  modal_interval_select_placeholder: 'Период: Указать период',
  modal_interval_or: 'или',
  aggregate: {
    mid: 'среднее',
    sum: 'сумма',
    count: 'количество',
    min: 'минимум',
    max: 'максимум',
    prop_sum: 'доля от суммы по столбцу',
    prop_num: 'доля',
  },
  date_select: {
    h: 'Час',
    d: 'День',
    w: 'Неделя',
    m: 'Месяц',
  },
  add_chart: 'Добавить диаграмму',
  settings: 'Общие настройки',
  axisSettings: 'Настройки осей',
  additionalSettings: 'Дополнительные настройки',
  chart_name: 'Название диаграммы',
  not_filled: 'Поле не заполнено',
  diagram_type: 'Тип диаграммы',
  default: 'Данные за период',
  display_values: 'Значения на диаграмме',
  display_legend: 'Легенду',
  nullable_values: 'Нулевые значения',
  order_by: 'Сортировка',
  empty_values: 'Значения “пусто“',
  max_group_display: 'Количество групп значений',
  data_hor_x: 'Выбор источника  (Ось X)',
  data_x: 'Тип источника',
  line_settings: 'Линия (область) нормы',
  line_settings_color: 'Цвет',
  line_settings_value: 'Значение',
  styles: 'Дополнительные настройки стилей',
  styles_header_size: 'Размер шрифта названия диаграммы',
  styles_text_size: 'Размер шрифта значений',
  styles_text_color: 'Цвет шрифта значений',
  styles_value_position: 'Расположение значений',
  styles_grid: 'Отображение направляющих',
  styles_legend_position: 'Расположение легенды',
  data_settings: 'Настройка рядов (Ось Y%{index})',
  conditional_formatting_add: 'Добавить настройки условного форматирования',
  conditional_formatting: 'Условное форматирование',
  conditional_formatting_axis: 'Ось',
  conditional_formatting_value: 'Диапазон',
  conditional_formatting_from: 'от',
  conditional_formatting_before: 'до',
  choose: 'Выбрать',
  date_call: 'Дата и время записи',
  metric: 'Метрика - значения',
  analytic_project: 'Аналитический проект',
  ap: 'АП',
  palettes: 'Наборы цветов',
  palette: 'Набор цветов',
  chart_toolbar: {
    download: 'Скачать',
    selection: 'Выбрать',
    selectionZoom: 'Увеличить выбранное',
    zoomIn: 'Увеличить',
    zoomOut: 'Уменьшить',
    pan: 'Переместить',
    reset: 'Сбросить настройки',
  },
  palette_save: 'Сохранить порядок',
  palette_cancel: 'Отмена',
  radialCharts: 'Радиальные диаграммы',
  radialBars: 'Радиальные бары',
  heatMap: 'Тепловая карта',
  donut: 'Кольцевая диаграмма',
  areaCharts: 'Линейный с заливкой',
  max_value_limit: 'Максимальное значение',
  comparison_enabled: 'Сравнение с предыдущим периодом',
  comparison_mode: 'Режим сравнения',
  comparison_font_size: 'Размер шрифта сравнения',
  comparison_positive_color: 'Цвет шрифта для положительной динамики',
  comparison_negative_color: 'Цвет шрифта для отрицательной динамики',
  comparison_mode_percent: 'Процентное соотношение',
  comparison_mode_absolute: 'Абсолютное значение',
  number: 'Число',
  last: 'Последние',
  current: 'Текущий',
  prev: 'Предыдущий',
  dayInHour: '24 часа',
  display: 'Отображать',
  font: 'Шрифт',
  display_axis_vertical: 'Ось (вертикальная)',
  display_axis_horizontal: 'Ось (горизонтальная)',
  styles_grid_vertical: 'Направляющие (вертикальные)',
  styles_grid_horizontal: 'Направляющие (горизонтальные)',
  additionally: 'Дополнительно',
  metric_reverse_categories: 'Метрика - названия',
  add_row: 'Добавить ряд',
  line_settings_hint: 'Отображается в виде линии в случае одинаковых значений “от” и “до”',
  max_group_display_hint:
    'Позволяет сгруппировать диаграмму при большом количество значений в оси X',
  max_value_limit_hint: 'Позволяет ограничить ось X по максимальному значению',
  palette_not_selected: 'Набор не выбран',
  generate_colors_column: 'Сгенерировать цвета для всех рядов',
  generate: 'Сгенерировать',
  categories_len: 'Количество категорий',
  categories_len_hint: 'Позволяет ограничить количество отображаемых категорий на графике',
  metric_filter: 'Фильтр по метрике',
  filter_value_placeholder: 'Введи значение',
  from: 'от',
  to: 'до',
  day: 'День',
  week: 'Неделя',
  month: 'Месяц',
  quarter: 'Квартал',
  range_interval_from: 'от',
  range_interval_to: 'до',
  num_font: 'Шрифт числа',
  color: 'Цвет',
  single_color: 'Один цвет',
};
